<template>
  <div class="row">
    <div class="col-12">
      <div class="integration__header">
        <div class="d-flex flex-column">
          <h3 class="mb-1 emm__page-heading text-uppercase">
            {{ $route.params.slug }}
          </h3>
          <span class="emm__page-sub-heading">Get your emails to the inbox—where they belong</span>
        </div>
      </div>
      <!-- <card bodyClasses="rounded-2" class="overflow-hidden rounded-2 mb-0 mt-5">
        <h4>Campaigns Attatched</h4>
      </card> -->
      <card bodyClasses="rounded-2" class="overflow-hidden rounded-2 mb-0 mt-5">
        <div class="d-flex align-items-end justify-content-between">
          <h4>{{ $route.params.slug }} configuration</h4>
          <base-button id="btnSaveIntegration" @click="saveIntegrationSettingslocal" :disabled="isLoading || !userApiKey"
            class="m-0">Save</base-button>
        </div>
        <div style="gap: 12px" class="d-flex flex-column mt-4">
          <base-checkbox v-model="integrationDetails.enable_sendgrid">Enable {{ $route.params.slug }}</base-checkbox>
          <base-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
            class="flex-grow-1 mb-0" v-model="userApiKey" aria-controls="datatables">
          </base-input>
        </div>
        <!-- <div class="mt-lg-5 d-flex align-items-end justify-content-end">
          <base-button @click="saveIntegrationSettingslocal" :disabled="isLoading || !userApiKey"
            class="m-0">Save</base-button>
        </div> -->
        <!-- <div class="mt-4">
          <label class="d-block mb-0" for="contact-upload"
            >Upload your contact list</label
          >
       
          <form enctype="multipart/form-data">
          
            <div class="dropbox">
              <input
                id="contact-upload"
                type="file"
                :name="uploadFieldName"
                :disabled="isSaving"
                @change="
                  filesChange($event.target.name, $event.target.files);
                  fileCount = $event.target.files.length;
                "
                accept=".csv"
                class="input-file"
              />
              <p>
                Drag your csv file here to upload<br />or click to browse<br />
                <base-button
                  type="info"
                  round
                  icon
                  @click="show_helpguide('optoutlist')"
                >
                  <i class="fas fa-question"></i>
                </base-button>
              </p>
              <p v-if="isSaving">
                Please Wait, your file is being processed ...
              </p>
              <p v-if="isSuccess">Process finished successfully, Thank you!</p>
              <p v-if="isFailed">
                Whoops that did not work, please check your file for errors and
                try again
              </p>
            </div>
          </form>
        </div> -->
      </card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userData"]),
    companyId() {
      return this.userData.company_id
      // if (this.userData.user_type == 'client') {
      //   return this.userData.company_parent;
      // } else {
      //   return this.userData.company_id;
      // }
    },
  },
  data() {
    return {
      userApiKey: '',
      isLoading: false,
      integrationDetails: {}
    }
  },
  async created() {
    this.integrationDetails = await this.getUserIntegrationDetails({ companyID: this.companyId, slug: this.$route.params.slug })
    var _integrationDetails = this.integrationDetails;

    if (_integrationDetails && Array.isArray(_integrationDetails)) {
                    _integrationDetails.forEach(item => {
                        this.integrationDetails.enable_sendgrid = item.enable_sendgrid === 1;
                        this.userApiKey = item.api_key ? item.api_key : '';
                    });
    }else {
      console.error("Integration details not found or not in the expected format.");
    }

  },
  mounted() {

  },
  methods: {
    ...mapActions(["saveIntegrationSettings", "getUserIntegrationDetails"]),
    async saveIntegrationSettingslocal() {
      $('#btnSaveIntegration').html('Saving...');   
      this.isLoading = true
      let data = {
        integration_slug: this.$route.params.slug,
        company_id: this.companyId,
        api_key: this.userApiKey,
        enable_sendgrid: this.integrationDetails.enable_sendgrid ? 1 : 0,
      }
      await this.saveIntegrationSettings({ data })
      $('#btnSaveIntegration').html('Save');
      this.isLoading = false
    },
  }



};
</script>

<style></style>